"use client";
import React, { useEffect, useState } from "react";
import { v4 as uuidv4 } from "uuid";
import "./print.css";
import {
  Form,
  Input,
  DatePicker,
  Radio,
  Select,
  Button,
  Row,
  Col,
  Space,
  Checkbox,
} from "antd";
import {
  SaveOutlined,
  PrinterOutlined,
  CloseOutlined,
  PlusCircleOutlined,
} from "@ant-design/icons";
import { request } from "../../share/request";
import CreatePopconfirm from "../../share/CreatePopconfirm";
import { openNotification } from "../../share/message";
import dayjs from "dayjs";
import { getCurrentUser } from "../../share/getProfile";
import e from "cors";
const { TextArea } = Input;
const { Option } = Select;

const DonorRegisterForm = ({ closeForm, update_form, updateid }) => {
  const [form] = Form.useForm();
  const [disabledVillagePop, setDisableVillagePop] = useState(false);
  const [disabledComPop, setDisabledComPop] = useState(false);
  const [list_city, setListCity] = useState([]);
  const [list_com, setListCom] = useState([]);
  const [list_village, setListVillage] = useState([]);
  const [id, setId] = useState("");
  const [province, setProvince] = useState("");
  const [city, setCity] = useState("");
  const [com, setCom] = useState("");
  const [village, setVillage] = useState("");
  const [proCode, setProCode] = useState(null);
  const [cityCode, setCityCode] = useState(null);
  const [comCode, setComCode] = useState(null);
  const [villageCode, setVillageCode] = useState(null);
  const [openDistrict, setOpenDistrict] = useState(false);
  const [openCommune, setOpenCommune] = useState(false);
  const [openVillage, setOpenVillage] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const getProfile = getCurrentUser();
  const [ck_qrCode, setCkQrCode] = useState(false);
  const [list_province, setListProvince] = useState([
    {
      id: 1,
      province_code: "1",
      Type: "ខេត្ត",
      province_name_khmer: "ខេត្តបន្ទាយមានជ័យ",
      province_name_latin: "Banteay Meanchey Province",
      reference: "ប្រកាសលេខ ៤៩៣ ប្រ.ក",
      noted: null,
    },
    {
      id: 2,
      province_code: "2",
      Type: "ខេត្ត",
      province_name_khmer: "ខេត្តបាត់ដំបង",
      province_name_latin: "Battambang Province",
      reference: "លេខ​៤៩៣ប្រ.ក",
      noted: null,
    },
    {
      id: 3,
      province_code: "3",
      Type: "ខេត្ត",
      province_name_khmer: "ខេត្តកំពង់ចាម",
      province_name_latin: "Kampong Cham Province",
      reference: "ប្រកាសលេខ ៤៩៣ ប្រ.ក",
      noted: null,
    },
    {
      id: 4,
      province_code: "4",
      Type: "ខេត្ត",
      province_name_khmer: "ខេត្តកំពង់ឆ្នាំង",
      province_name_latin: "Kampong Chhnang Province",
      reference: "ប្រកាសលេខ ៤៩៣ ប្រ.ក",
      noted: null,
    },
    {
      id: 5,
      province_code: "5",
      Type: "ខេត្ត",
      province_name_khmer: "ខេត្តកំពង់ស្ពឺ",
      province_name_latin: "Kampong Speu Province",
      reference: "លេខ​៤៩៣​ប្រ,ក",
      noted: null,
    },
    {
      id: 6,
      province_code: "6",
      Type: "ខេត្ត",
      province_name_khmer: "ខេត្តកំពង់ធំ",
      province_name_latin: "Kampong Thom Province",
      reference: "ប្រកាសលេខ ៤៩៣​ ប្រ.ក",
      noted: null,
    },
    {
      id: 7,
      province_code: "7",
      Type: "ខេត្ត",
      province_name_khmer: "ខេត្តកំពត",
      province_name_latin: "Kampot Province",
      reference: "ប្រកាសលេខ ៤៩៣ ​ប្រ.ក របស់ក្រសួងមហាផ្ទៃ",
      noted: null,
    },
    {
      id: 8,
      province_code: "8",
      Type: "ខេត្ត",
      province_name_khmer: "ខេត្តកណ្ដាល",
      province_name_latin: "Kandal Province",
      reference: "ប្រកាសលេខ ៤៩៣​ ប្រ.ក",
      noted: null,
    },
    {
      id: 9,
      province_code: "9",
      Type: "ខេត្ត",
      province_name_khmer: "ខេត្តកោះកុង",
      province_name_latin: "Koh Kong Province",
      reference: "ប្រកាសលេខ ៤៩៣ ប្រ.ក របស់ក្រសួងមហាផ្ទៃ",
      noted: null,
    },
    {
      id: 10,
      province_code: "10",
      Type: "ខេត្ត",
      province_name_khmer: "ខេត្តក្រចេះ",
      province_name_latin: "Kratie Province",
      reference: "ប្រកាសលេខ ៤៩៣ ប្រ.ក",
      noted: null,
    },
    {
      id: 11,
      province_code: "11",
      Type: "ខេត្ត",
      province_name_khmer: "ខេត្តមណ្ឌលគិរី",
      province_name_latin: "Mondul Kiri Province",
      reference: "ប្រកាសលេខ ៤៩៣ ប្រ.ក",
      noted: null,
    },
    {
      id: 12,
      province_code: "12",
      Type: "ខេត្ត",
      province_name_khmer: "រាជធានីភ្នំពេញ",
      province_name_latin: "Phnom Penh Capital",
      reference: "ប្រកាសលេខ ៤៩៣ ប្រ.ក",
      noted: null,
    },
    {
      id: 13,
      province_code: "13",
      Type: "ខេត្ត",
      province_name_khmer: "ខេត្តព្រះវិហារ",
      province_name_latin: "Preah Vihear Province",
      reference: "ប្រកាសលេខ ៤៩៣ ប្រ.ក",
      noted: null,
    },
    {
      id: 14,
      province_code: "14",
      Type: "ខេត្ត",
      province_name_khmer: "ខេត្តព្រៃវែង",
      province_name_latin: "Prey Veng Province",
      reference: "ប្រកាសលេខ ៤៩៣​ ប្រ.ក",
      noted: null,
    },
    {
      id: 15,
      province_code: "15",
      Type: "ខេត្ត",
      province_name_khmer: "ខេត្តពោធិ៍សាត់",
      province_name_latin: "Pursat Province",
      reference: "លេខ​៤៩៣​ប្រ.ក",
      noted: null,
    },
    {
      id: 16,
      province_code: "16",
      Type: "ខេត្ត",
      province_name_khmer: "ខេត្តរតនគិរី",
      province_name_latin: "Ratanak Kiri Province",
      reference: "ប្រកាសលេខ ៤៩៣ ប្រ.ក",
      noted: null,
    },
    {
      id: 17,
      province_code: "17",
      Type: "ខេត្ត",
      province_name_khmer: "ខេត្តសៀមរាប",
      province_name_latin: "Siemreap Province",
      reference: "ប្រកាសលេខ ៤៩៣ ប្រ.ក",
      noted: null,
    },
    {
      id: 18,
      province_code: "18",
      Type: "ខេត្ត",
      province_name_khmer: "ខេត្តព្រះសីហនុ",
      province_name_latin: "Preah Sihanouk Province",
      reference: "ព្រះរាជក្រឹត្យលេខ នស/រកត/១២០៨/១៣៨៥",
      noted: null,
    },
    {
      id: 19,
      province_code: "19",
      Type: "ខេត្ត",
      province_name_khmer: "ខេត្តស្ទឹងត្រែង",
      province_name_latin: "Stung Treng Province",
      reference: "ប្រកាសលេខ ៤៩៣ ប្រ.ក",
      noted: null,
    },
    {
      id: 20,
      province_code: "20",
      Type: "ខេត្ត",
      province_name_khmer: "ខេត្តស្វាយរៀង",
      province_name_latin: "Svay Rieng Province",
      reference: "ប្រកាសលេខ ៤៩៣​ ប្រ.ក",
      noted: null,
    },
    {
      id: 21,
      province_code: "21",
      Type: "ខេត្ត",
      province_name_khmer: "ខេត្តតាកែវ",
      province_name_latin: "Takeo Province",
      reference: "ប្រកាសលេខ ៤៩៣​ ប្រ.ក",
      noted: null,
    },
    {
      id: 22,
      province_code: "22",
      Type: "ខេត្ត",
      province_name_khmer: "ខេត្តឧត្ដរមានជ័យ",
      province_name_latin: "Oddar Meanchey Province",
      reference: "ប្រកាសលេខ ៤៩៣ ប្រ.ក",
      noted: null,
    },
    {
      id: 23,
      province_code: "23",
      Type: "ខេត្ត",
      province_name_khmer: "ខេត្តកែប",
      province_name_latin: "Kep Province",
      reference: "ព្រះរាជក្រឹត្យលេខ នស/រកត/១២០៨/១៣៨៣",
      noted: null,
    },
    {
      id: 24,
      province_code: "24",
      Type: "ខេត្ត",
      province_name_khmer: "ខេត្តប៉ៃលិន",
      province_name_latin: "Pailin Province",
      reference: "នស/រកម/1208/1384​",
      noted: null,
    },
    {
      id: 25,
      province_code: "25",
      Type: "ខេត្ត",
      province_name_khmer: "ខេត្តត្បូងឃ្មុំ",
      province_name_latin: "Tboung Khmum Province",
      reference: "ព្រះរាជក្រឹក្យលេខ នស/រកត/១២១៣/១៤៤៥",
      noted: null,
    },
  ]);
  useEffect(() => {
    if (!updateid) {
      setCityCode(null);
      setComCode(null);
      setVillageCode(null);
      setProCode(null);
      setCity("");
      setCom("");
      setVillage("");
      form.resetFields();
      return;
      // Also reset the corresponding codes
    }
    if (update_form) {
      setCkQrCode(false);
      console.table("update form restiger", update_form);
      const dobDate = dayjs(update_form.dob);
      form.setFieldsValue({
        ...update_form,
        gender: update_form.gender === "Male" ? "ប្រុស" : "ស្រី",
        maritalStatus:
          update_form.marital_status === "Single" ? "នៅលីវ" : "រៀបការ",
        fullName_kh: update_form.full_name_kh,
        fullName_en: update_form.full_name_eng,
        nationalId: update_form.national_id,
        dob: dobDate.isValid() ? dobDate : null, // ✅ safe check for dayjs

        qrCodeId: update_form.ingerate_qrcode_id,
        house_number: update_form.address_house,
        street_number: update_form.address_street,
        province: update_form.province_kh,
        city: update_form.city_kh,
        commune: update_form.commune_kh,
        village: update_form.village_kh,
        workPlace: update_form.workplace,
          position: update_form.position,
      });
      setCity(update_form.city_kh || null);
      setCom(update_form.commune_kh || null);
      setVillage(update_form.village_kh || null);
      setProCode(update_form.province || null);
      setCityCode(update_form.district || null);
      setComCode(update_form.commune || null);
      setVillageCode(update_form.village || null);
    }
  }, [updateid, update_form]);

  const [txtInputDriver, setTxtInputDriver] = useState("");
  const onChangeInputDriver = (e) => {
    setTxtInputDriver(e.target.value);
  };

  const [loading, setLoading] = useState(false);
  const handleOk = async () => {
    setConfirmLoading(true);
    const data = {
      param_type: openDistrict
        ? "district"
        : openCommune
        ? "commune"
        : openVillage
        ? "village"
        : "",
      param_code: openDistrict
        ? proCode
        : openCommune
        ? cityCode
        : openVillage
        ? comCode
        : "",
      param_value: txtInputDriver,
    };

    const res = await request("casecreateaddress", "post", data);
    if (res) {
      openNotification("success", "Success", res.message);
      setTxtInputDriver("");
    } else {
      openNotification("error", "Error", "Failed to add new entry.");
    }

    setTimeout(() => {
      setConfirmLoading(false);
      setOpenDistrict(false);
      setOpenCommune(false);
      setOpenVillage(false);
    }, 1000);
  };
  const handleCancel_pro = () => {
    setOpenDistrict(false);
    setOpenCommune(false);
    setOpenVillage(false);
    setTxtInputDriver("");
  };
  const onChangeProvince = async (value) => {
    console.log("onChangeProvince", value);
    setProvince(value);
    setProCode(value);

    // Reset city, commune, and village when province changes
    form.setFieldsValue({
      city: undefined,
      commune: undefined,
      village: undefined,
    });
    // Also reset the corresponding codes
    setCityCode(null);
    setComCode(null);
    setVillageCode(null);
    setCity("");
    setCom("");
    setVillage("");

    // Clear the lists for commune and village when province changes
    setListCity([]);
    setListCom([]);
    setListVillage([]);

    const res = await request("useraddresscity/" + value, "get", {});
    console.log("API response:", res);
    if (res && res.API_Server_listCity) {
      setListCity(res.API_Server_listCity);
    }
    setDisabledComPop(false);
    setDisableVillagePop(false);
  };
  const onChangeCity = async (value) => {
    console.log("onChangeCity", value);
    setCityCode(value);
    setCity(value);
    setCom("");
    setVillage("");
    setListCom([]);
    setListVillage([]);
    const res = await request("useraddresscom/" + value, "get", {});
    console.log("API response:", res);
    if (res && res.API_Server_listCom) {
      setListCom(res.API_Server_listCom);
    }
    setDisabledComPop(true);
    setDisableVillagePop(false);
  };
  const onClickCity = async () => {
    console.log("province code is : ", proCode);
    const res = await request("useraddresscity/" + proCode, "get", {});
    console.log("API response:", res);
    if (res && res.API_Server_listCity) {
      setListCity(res.API_Server_listCity);
    }
  };
  const onChangeCom = async (value) => {
    setCom(value);
    setComCode(value);
    setVillage("");
    console.log("com code is : ", value);
    const res = await request("useraddressvillage/" + value, "get", {});
    console.log("API response:", res);
    if (res && res.API_Server_listVillage) {
      setListVillage(res.API_Server_listVillage);
    }
    setDisableVillagePop(true);
  };

  const onChangeVillage = async (value) => {
    console.log("on change village ", value);
    setVillage(value);
    setVillageCode(value);
  };
  const onClickCom = async () => {
    console.log("com code is : ", comCode);
    const res = await request("useraddresscom/" + cityCode, "get", {});
    console.log("API response:", res);
    if (res && res.API_Server_listCom) {
      setListCom(res.API_Server_listCom);
    }
  };
  const onClickVillage = async () => {
    const res = await request("useraddressvillage/" + comCode, "get", {});
    console.log("API response:", res);
    if (res && res.API_Server_listVillage) {
      setListVillage(res.API_Server_listVillage);
    }
  };
  const dobRaw = form.getFieldValue("dob");
  const donationDateRaw = form.getFieldValue("donationDate");
  const qrCodeIdAuto = uuidv4(); // Example: "e4c5a7d0-942a-4c3b-bf69-5c46937f9aab"
  const onHandleSave = async () => {
    setLoading(true);
    try {
      const data = {
        ...form.getFieldsValue(),
        dob: dayjs(form.getFieldValue("dob")).format("YYYY-MM-DD"), // Format date to YYYY-MM-DD
        donationDate: donationDateRaw
          ? dayjs(donationDateRaw).format("YYYY-MM-DD")
          : null,
        gender: form.getFieldValue("gender") === "ប្រុស" ? "Male" : "Female",
        maritalStatus:
          form.getFieldValue("maritalStatus") === "នៅលីវ"
            ? "Single"
            : "Married",
        province: proCode,
        city: cityCode,
        commune: comCode,
        village: villageCode,
        qrCodeId:
          updateid === null
            ? form.getFieldValue("qrCodeId") || qrCodeIdAuto
            : form.getFieldValue("qrCodeId") || qrCodeIdAuto,
        org_code: getProfile.org_code,
        create_by: getProfile.fullname,
      };

      let res;
      console.log("Data to be sent:", data);
      if (updateid) {
        // Updating
        res = await request(`donatorregister/${updateid}`, "put", data);
      } else {
        // Creating
        res = await request("donatorregister", "post", data);
      }

      if (res) {
        openNotification("success", "Success", res.message);
        form.resetFields();
        closeForm(); // close modal after save
      } else {
        openNotification("error", "Error", "Failed to save data.");
      }
    } catch (error) {
      console.error(error);
      openNotification("error", "Error", "Something went wrong.");
    } finally {
      setLoading(false);
    }
  };

  const onHandleClose = () => {
    closeForm();
  };

  const handleCheckboxChange = (e) => {
    setCkQrCode(e.target.checked); // ✅ This handles both check/uncheck
  };
  return (
    <div
      className="khmer-font"
      style={{ maxWidth: 900, margin: "auto", padding: 20 }}
    >
      <Form form={form} layout="vertical">
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item
              label="ឈ្មោះពេញ(ភាសាខ្មែរ)"
              name="fullName_kh"
              rules={[{ required: true }]}
            >
              <Input placeholder="បញ្ចូលឈ្មោះ" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              label="ឈ្មោះពេញ(ភាសាអង់គ្លេស)"
              name="fullName_en"
              rules={[{ required: true }]}
            >
              <Input placeholder="បញ្ចូលឈ្មោះ" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="លេខអត្តសញ្ញាណប័ណ្ណ" name="nationalId">
              <Input placeholder="លេខអត្តសញ្ញាណ" />
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={6}>
            <Form.Item label="ថ្ងៃខែឆ្នាំកំណើត" name="dob">
              <DatePicker
                format="DD/MM/YYYY"
                style={{ width: "100%" }}
                placeholder="ជ្រើសរើសថ្ងៃ"
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label="អាយុ" name="age">
              <Input type="number" placeholder="អាយុ" />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label="ភេទ" name="gender">
              <Radio.Group>
                <Radio value="ប្រុស">ប្រុស</Radio>
                <Radio value="ស្រី">ស្រី</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item label="ស្ថានភាពគ្រួសារ" name="maritalStatus">
              <Radio.Group>
                <Radio value="នៅលីវ">នៅលីវ</Radio>
                <Radio value="រៀបការ">រៀបការ</Radio>
              </Radio.Group>
            </Form.Item>
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}>
  <Form.Item label="មុខរបរ" name="occupation">
    <Select placeholder="ជ្រើសរើស​មុខរបរ" style={{height:40}}>
      <Select.Option value="មន្ត្រីរាជការ">មន្ត្រីរាជការ</Select.Option>
      <Select.Option value="ព្រះសង្ឃ">ព្រះសង្ឃ</Select.Option>
      <Select.Option value="អាជីវករ">អាជីវករ</Select.Option>
      <Select.Option value="ប្រជាពលរដ្ឋ">ប្រជាពលរដ្ឋ</Select.Option>
      <Select.Option value="កសិករ">កសិករ</Select.Option>
      <Select.Option value="កម្មករ">កម្មករ</Select.Option>
       <Select.Option value="មេផ្ទះ">មេផ្ទះ</Select.Option>
      <Select.Option value="ផ្សេងៗ">ផ្សេងៗ</Select.Option>
    </Select>
  </Form.Item>
</Col>

          <Col span={12}>
            <Form.Item label="អង្គភាពធ្វើការ" name="workPlace">
              <Input placeholder="អង្គភាពធ្វើការ" />
            </Form.Item>
          </Col>
             <Col span={12}>
            <Form.Item label="តួនាទីក្នងអង្គភាពធ្វើការ" name="position">
              <Input placeholder="បញ្ជូលតួនាទី" />
            </Form.Item>
          </Col>
        </Row>
        <Form.Item label="អាសយដ្ឋានបច្ចុប្បន្ន" name="address">
          {/* province,city, district, commune, village steetnumber */}
          <Row gutter={16}>
            <Col span={4}>
              <Form.Item name="province" label="ខេត្ត/ក្រុង">
                <Select
                  className="styleTageStatusForm"
                  placeholder="Select an Province"
                  onChange={onChangeProvince}
                  value={province}
                >
                  {list_province.map((option) => (
                    <Option
                      className="styleTageStatusForm"
                      key={option.province_code}
                      value={option.province_code}
                    >
                      {option.province_name_khmer}
                      {/* Replace with the field from your MySQL table */}
                    </Option>
                  ))}
                </Select>
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item name="city" label="ស្រុក/ក្រុង">
                <Select
                  value={city}
                  className="styleTageStatusForm"
                  placeholder="Select an City"
                  onChange={onChangeCity}
                  onClick={onClickCity}
                  disabled={!list_city.length}
                >
                  {list_city.map((option) => (
                    <Option
                      className="styleTageStatusForm"
                      key={option.city_code}
                      value={option.city_code}
                    >
                      {option?.city_name_khmer || null}{" "}
                    </Option>
                  ))}
                </Select>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: 5,
                    color: !list_city.length ? "#aaa" : "red",
                    pointerEvents: !list_city.length ? "none" : "auto",
                    gap: 5,
                  }}
                >
                  <PlusCircleOutlined />
                  <a
                    onClick={() => {
                      setOpenDistrict(true);
                      setOpenCommune(false);
                      setOpenVillage(false);
                    }}
                    style={{
                      width: 50,
                    }}
                  >
                    បង្កើតថ្មី
                  </a>
                  <CreatePopconfirm
                    disabled={!list_city.length}
                    openPop={openDistrict}
                    caption={"បង្កើតស្រុក (Create District)"}
                    onChangeInputDriver={onChangeInputDriver}
                    handleOk={handleOk}
                    confirmLoading={confirmLoading}
                    handleCancel_pro={handleCancel_pro}
                  />
                </div>
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item name="commune" label="សង្កាត់/ឃុំ">
                <Select
                  className="styleTageStatusForm"
                  placeholder="Select an Commune"
                  onChange={onChangeCom}
                  onClick={onClickCom}
                  value={com}
                  disabled={!disabledComPop}
                >
                  {list_com.map((option) => (
                    <Option
                      className="styleTageStatusForm"
                      key={option.com_code}
                      value={option.com_code}
                    >
                      {option?.com_name_khmer || null}{" "}
                    </Option>
                  ))}
                </Select>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: 5,
                    color: !disabledComPop ? "#aaa" : "red",
                    pointerEvents: !disabledComPop ? "none" : "auto",
                    gap: 5,
                  }}
                >
                  <PlusCircleOutlined />
                  <a
                    onClick={() => {
                      setOpenCommune(true);
                      setOpenVillage(false);
                      setOpenDistrict(false);
                    }}
                    style={{ width: 50 }}
                  >
                    បង្កើតថ្មី
                  </a>
                  <CreatePopconfirm
                    disabled={!disabledComPop}
                    openPop={openCommune}
                    caption={"បង្កើតឃុំ (Create Commune)"}
                    onChangeInputDriver={onChangeInputDriver}
                    handleOk={handleOk}
                    confirmLoading={confirmLoading}
                    handleCancel_pro={handleCancel_pro}
                  />
                </div>
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item name="village" label="ភូមិ">
                <Select
                  className="styleTageStatusForm"
                  placeholder="Select an Village"
                  onChange={onChangeVillage}
                  onClick={onClickVillage}
                  value={village}
                  disabled={!disabledVillagePop}
                >
                  {list_village.map((option) => (
                    <Option
                      className="styleTageStatusForm"
                      key={option.village_code}
                      value={option.village_code}
                    >
                      {option?.village_name_khmer || null}{" "}
                      {/* Replace with the field from your MySQL table */}
                    </Option>
                  ))}
                </Select>
                <div
                  style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    marginTop: 5,
                    color: !disabledVillagePop ? "#aaa" : "red",
                    pointerEvents: !disabledVillagePop ? "none" : "auto",
                    gap: 5,
                  }}
                >
                  <PlusCircleOutlined />
                  <a
                    onClick={() => {
                      setOpenVillage(true);
                      setOpenCommune(false);
                      setOpenDistrict(false);
                    }}
                    style={{ width: 50 }}
                  >
                    បង្កើតថ្មី
                  </a>
                  <CreatePopconfirm
                    disabled={!disabledVillagePop}
                    openPop={openVillage}
                    caption={"បង្កើតភូមិ (Create Village)"}
                    onChangeInputDriver={onChangeInputDriver}
                    handleOk={handleOk}
                    confirmLoading={confirmLoading}
                    handleCancel_pro={handleCancel_pro}
                  />
                </div>
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item name="house_number" label="ផ្ទះលេខ">
                <Input />
              </Form.Item>
            </Col>
            <Col span={4}>
              <Form.Item name="street_number" label="ផ្លូវលេខ">
                <Input />
              </Form.Item>
            </Col>
          </Row>
        </Form.Item>
        <Row gutter={16}>
          <Col span={8}>
            <Form.Item label="លេខទូរស័ព្ទ" name="phone1">
              <Input placeholder="លេខទូរស័ព្ទ" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item label="អ៊ីមែល" name="email1">
              <Input placeholder="example@email.com" />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="qrCodeId"
              label={
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <Checkbox onChange={handleCheckboxChange} /> លេខកូដ QR
                </div>
              }
            >
              <Input disabled={!ck_qrCode} />
            </Form.Item>
            {/* <Form.Item label="ថ្ងៃខែបរិច្ចាកឈាម" name="donationDate">
              <DatePicker
                format="DD/MM/YYYY"
                style={{ width: "100%" }}
                placeholder="ជ្រើសរើសថ្ងៃ"
              />
            </Form.Item> */}
          </Col>
        </Row>
        <Row gutter={16}>
          <Col span={12}></Col>
          <Col span={12}>
            <Space>
              <Form.Item>
                <Button
                  onClick={onHandleSave}
                  style={{ width: "100px" }}
                  type="primary"
                  htmlType="submit"
                  loading={loading}
                  block
                  icon={<SaveOutlined />}
                >
                  រក្សាទុក
                </Button>
              </Form.Item>

              <Form.Item>
                <Button
                  style={{ width: "100px" }}
                  type="default"
                  htmlType="button"
                  block
                  icon={<PrinterOutlined />}
                >
                  បោះពុម្ព
                </Button>
              </Form.Item>

              <Form.Item>
                <Button
                  style={{ width: "100px" }}
                  danger
                  type="default"
                  htmlType="button"
                  onClick={onHandleClose}
                  block
                  icon={<CloseOutlined />}
                >
                  បោះបង់
                </Button>
              </Form.Item>
            </Space>
          </Col>
        </Row>
      </Form>
    </div>
  );
};

export default DonorRegisterForm;
